import React from 'react';
import moment from 'moment';
import { findIndex } from 'underscore';
import { SingleDatePicker, DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

class CustomDateRangePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      date: null,
      focusedInput: null,
      startDate: null,
      endDate: null,
      enableOutsideDays: true,
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.onFocusChangeRange = this.onFocusChangeRange.bind(this);
    this.isOutsideRange = this.isOutsideRange.bind(this);
  }
  componentWillMount() {
    const datepickertype = this.props.datepickertype;
    this.setState({ datepickertype, startDate: this.props.default.hasOwnProperty('start') ? moment(this.props.default.start) : null, endDate: this.props.default.hasOwnProperty('end') ? moment(this.props.default.end) : null });
  }
  componentWillReceiveProps(nextProps) {
    const datepickertype = nextProps.datepickertype;
    this.setState({ datepickertype, startDate: nextProps.default.hasOwnProperty('start') ? moment(nextProps.default.start) : null, endDate: nextProps.default.hasOwnProperty('end') ? moment(nextProps.default.end) : null  });
  }
  onDateChange(date) {
    if (this.state.datepickertype === 'single') {
      const values = [];
      const startDate = moment(date).format('YYYY-MM-DD');
      const endDate = moment(date).format('YYYY-MM-DD');
      values.push(startDate);
      values.push(endDate);
      this.props.grabDateRangeValue(values);
      this.setState({ startDate: moment(startDate) });
    } else {
      if (date.startDate !== null && date.endDate !== null) {
        const values = [];
        const startDate = moment(date.startDate).format('YYYY-MM-DD');
        const endDate = moment(date.endDate).format('YYYY-MM-DD');
        values.push(startDate);
        values.push(endDate);
        this.props.grabDateRangeValue(values);
      }
      this.setState({ startDate: date.startDate, endDate: date.endDate });
    }
    // this.setState({ date });
  }
  onFocusChange(data) {
    this.setState({ focused: data.focused });
  }
  onFocusChangeRange(focusedInput) {
    this.setState({ focusedInput });
  }
  isOutsideRange() {
    return false;
  }
  handleDateChange(e) {
    e.preventDefault();
  }

  render() {
    const { focused, startDate, endDate, focusedInput, datepickertype } = this.state;
    const monthnumber = this.props.monthView === 'single' ? 1 : 2;
    return (<div>
    {
      datepickertype === 'single' ?
        <SingleDatePicker
          id="date_input"
          date={startDate}
          focused={focused}
          displayFormat={this.props.dateFormat}
          numberOfMonths={monthnumber}
          isOutsideRange={this.isOutsideRange}
          onDateChange={this.onDateChange}
          onFocusChange={this.onFocusChange}
          orientation={monthnumber === 1 ? 'vertical' : 'horizontal' }
        /> :
      <DateRangePicker
        {...this.props}
        onDatesChange={this.onDateChange}
        onFocusChange={this.onFocusChangeRange}
        isOutsideRange={this.isOutsideRange}
        displayFormat={this.props.dateFormat}
        focusedInput={focusedInput}
        numberOfMonths={monthnumber}
        startDate={startDate}
        endDate={endDate}
        orientation={monthnumber === 1 ? 'vertical' : 'horizontal' }
      />
    }

    </div>);
  }
}

CustomDateRangePicker.propTypes = {
  'multiselect': React.PropTypes.string,
  'option': React.PropTypes.array,
  'defaultvalue': React.PropTypes.array,
  'grabDateRangeValue': React.PropTypes.func,
  'block': React.PropTypes.object,
};

export default CustomDateRangePicker;




// WEBPACK FOOTER //
// ./assets/src/frontend/element/daterangepicker.js